"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
/* eslint-disable react/jsx-indent */

var StyledButton = (0, _styledComponents["default"])(_buttons.Button).attrs({
  className: 'fuse-pagination__chevron-button',
  'data-testid': 'fuse-pagination__chevron-button'
}).withConfig({
  displayName: "styled-button-chevron__StyledButton",
  componentId: "sc-1hkwpt4-0"
})(["&{width:var(--spacing-global-space9);height:var(--spacing-global-space9);padding:0;margin-right:var(--spacing-global-space3);border:none;font-size:0;}&:active{box-shadow:none;}&:disabled{border:none;}&:hover:enabled{border:none;box-shadow:none;}&:before{background:var(--color-global-black);margin:0;}&:hover:enabled:before,&:focus:enabled:before,&:active:enabled:before{background:var(--color-brand-mid);}&:focus-visible:enabled{outline:2px solid var(--color-functional-focus);box-shadow:none;}&:focus:before{background:var(--color-brand-mid);}"]);
var _default = exports["default"] = StyledButton;